import { render } from "./DataDeletionRequest.vue?vue&type=template&id=1cd8bef8&scoped=true"
import script from "./DataDeletionRequest.vue?vue&type=script&lang=js"
export * from "./DataDeletionRequest.vue?vue&type=script&lang=js"

import "./DataDeletionRequest.vue?vue&type=style&index=0&id=1cd8bef8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1cd8bef8"]])

export default __exports__